import { defineStore } from 'pinia'
import { CompanyService } from '@/services/company.service'
import { useToast } from 'vue-toastification'

const toast = useToast()

interface Company {
  id: number;
  name: string;
}

interface CompanyState {
  companies: Company[];
  selectedCompanyId: string | null;
  loading: boolean;
  error: string | null;
}

export const useCompanyStore = defineStore('company', {
  state: (): CompanyState => ({
    companies: [],
    selectedCompanyId: localStorage.getItem('selectedCompanyId') || process.env.VUE_APP_DEFAULT_COMPANY_ID || null,
    loading: false,
    error: null
  }),

  actions: {
    async fetchCompanies() {
      this.loading = true
      this.error = null
      try {
        const response = await CompanyService.getCompanies()
        if (response.status === 'success' && response.data?.companies) {
          this.companies = response.data.companies
        } else {
          throw new Error(response.messages?.[0] || 'Failed to fetch companies')
        }
      } catch (error: any) {
        this.error = error.message
        toast.error(error.message)
        console.error('Failed to fetch companies:', error)
      } finally {
        this.loading = false
      }
    },

    async setSelectedCompany(companyId: string) {
      this.selectedCompanyId = companyId
      localStorage.setItem('selectedCompanyId', companyId)
    },

    clearSelectedCompany() {
      this.selectedCompanyId = null;
      localStorage.removeItem('selectedCompanyId');
    }
  }
})
